import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', canvasWidth, istemplate, index }) {
  var finalx = sprite.x;
  sprite.x = -(canvasWidth - sprite.x);
  let delay = 0;
  if (istemplate && index) {
    delay = index * (duration * speed);
  }
  var animation = gsap.to(sprite, {
    x: finalx,
    duration: duration * speed,
    ease: 'power3.out',
    paused: true,
    delay: delay,
  });
  return animation;
}
export default { Animate };
